import { TextField, InputAdornment } from '@mui/material'
import PropTypes from 'prop-types'
import { forwardRef } from 'react'
import { Controller } from 'react-hook-form'
import { NumericFormat } from 'react-number-format'

/**
 * @description Renders a currency field wrapped in a Controller component.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.decimalScale - The decimal scale of the currency value.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @returns {JSX.Element} - The rendered password input field.
 */
const FormInputCurrency = forwardRef(({ control, name, label, decimalScale = 2, errors, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field: { value, onChange } }) => (
                <NumericFormat
                    ref={ref}
                    value={value}
                    onValueChange={(values) => onChange(values.floatValue)}

                    thousandSeparator={'.'}
                    decimalSeparator={','}
                    decimalScale={decimalScale}
                    fixedDecimalScale={true}
                    allowNegative={false}
                    customInput={TextField}

                    label={label}
                    error={!!errors}
                    helperText={errors?.message}
                    onFocus={(event) => event.target.select()}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                R$
                            </InputAdornment>
                        ),
                    }}

                    {...props}
                />
            )}
        />
    )
})

FormInputCurrency.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    decimalScale: PropTypes.number,
    control: PropTypes.object,
    errors: PropTypes.object
}

FormInputCurrency.displayName = 'FormInputCurrency'

export default FormInputCurrency
